<template>


	<div class="row">
		<div class="col-lg-10 col-lg-offset-1">
			<div class="person-block clearfix">
				<div class="mv20 text-center" v-show="person.loading">
					<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
				</div>
				<div class="row" v-show="!person.loading">

					<div class="col-sm-3">
						<img v-if="person.image && person.image.url" class="img-rounded wp100" :src="person.image.url"/>
					</div>
					<div class="col-sm-9">
						<div class="f18 bold mt10">
							{{person.name}}

						</div>
						<div class="mv10 f16" v-if="person.title" v-html="titleHtml">

						</div>
						<div class="mv10 f14" v-if="person.phone">
							电话：{{person.phone}}

						</div>
						<div class="mv10" v-if="person.office">
							办公地点：{{person.office}}


						</div>
						<div class="mv10" v-if="person.email">
							邮件：{{person.email}}

						</div>
					</div>

					<div class="col-xs-12 mt10 mb40" v-if="person.description">
						<div v-html="person.description"></div>
					</div>


				</div>


			</div>

		</div>
	</div>


</template>

<script>
	import Person from  "../../../../common/model/person/Person"

	export default {
		data () {
			return {}
		},
		computed: {
			titleHtml(){
				let str = "";
				if (this.person.title) {
					let arr = this.person.title.split(" ");
					for (let i = 0; i < arr.length; i++) {
						str += arr[i] + "</br>";
					}
				}
				return str;

			}
		},
		props: {
			person: {
				type: Person,
				required: false,
				"default"(){
					return new Person();
				}
			}
		},
		components: {},
		watch: {},
		methods: {},
		mounted(){

		}
	}

</script>
<style lang="less" rel="stylesheet/less">

	.person-block {
		background-color: white;
		padding: 20px;
		border-radius: 5px;
	}
</style>




// WEBPACK FOOTER //
// PersonBlock.vue?27549d86